import { render, staticRenderFns } from "./newsdetail.vue?vue&type=template&id=08f9287b&scoped=true"
import script from "./newsdetail.vue?vue&type=script&lang=js"
export * from "./newsdetail.vue?vue&type=script&lang=js"
import style0 from "./newsdetail.vue?vue&type=style&index=0&id=08f9287b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08f9287b",
  null
  
)

export default component.exports